export default __webpack_public_path__ + "9fe1557aac44dad66ec18b99a6f76b92.webp";